import { createFileRoute } from "@tanstack/react-router";
import { CrudTable } from "@/features/admin/components/CrudTable";

export const Route = createFileRoute("/_authenticated/admin/testimonials")({
  component: () => (
    <CrudTable
      title="Testimonials"
      table="testimonials"
      orderBy={{ column: "sort_order", ascending: true }}
      columns={[
        { key: "author_name", label: "Author" },
        { key: "author_role", label: "Role" },
        { key: "rating", label: "Rating", render: (r) => "⭐".repeat(Number(r.rating ?? 5)) },
        { key: "is_published", label: "Published", render: (r) => (r.is_published ? "✅" : "❌") },
      ]}
      fields={[
        { key: "author_name", label: "Author Name", required: true },
        { key: "author_role", label: "Role (e.g. Parent of Yara, 10)" },
        { key: "content", label: "Quote", type: "textarea", required: true },
        { key: "rating", label: "Rating (1-5)", type: "number" },
        { key: "avatar_url", label: "Avatar URL" },
        { key: "sort_order", label: "Sort Order", type: "number" },
        { key: "is_published", label: "Published", type: "switch", defaultValue: true },
      ]}
    />
  ),
});
